import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const itemIndicatorsCellStyleId = 'item-indicators-cell-theme';

export const itemIndicatorsCellBridgeStyles = {
  'item-indicators-cell-renderer': {
    '--local-indicator-text': tokens.color.foreground.secondary,
    '--local-indicator-bg': tokens.color.background.primary,
    '--local-indicator-border': tokens.color.border.primary,
    '--local-indicator-gap': tokens.spacing.sm,
    '--local-indicator-success': tokens.color.foreground.successSecondary,
    '--local-indicator-success-bg': tokens.color.background.successPrimary,
    '--local-indicator-success-border': tokens.color.background.successSecondary,
    '--local-indicator-warning': tokens.color.foreground.warningSecondary,
    '--local-indicator-warning-bg': tokens.color.background.warningPrimary,
    '--local-indicator-warning-border': tokens.color.background.warningSecondary,
    '--local-indicator-error': tokens.color.foreground.errorSecondary,
    '--local-indicator-error-bg': tokens.color.background.errorPrimary,
    '--local-indicator-error-border': tokens.color.border.errorSubtle,
  },
};
